import { ContactType } from '@features/contacts/types/contactType'
import { ZervantContactType } from '@features/invoices/enums/zervantContactType'

const agerasToZervantContactTypeMap: Partial<Record<ContactType, ZervantContactType>> = {
  [ContactType.Company]: ZervantContactType.Company,
  [ContactType.Person]: ZervantContactType.Person,
}

export const getZervantContactType = (type?: ContactType): ZervantContactType =>
  agerasToZervantContactTypeMap[type || ContactType.Company] || ZervantContactType.Company
